// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  caseSummaryShowAllCasesToggle,
  deselectNonVisibleCases,
} from 'redux/modules/interferenceAnalysis'

const handleShowAllCasesToggle = newState => (dispatch, getState) => {
  dispatch(caseSummaryShowAllCasesToggle(newState))

  // by toggling this, you are going to be changing which cases are selectable/visible.
  // eg. you could just have hid a case which is currently selected.
  // as a result, we need to trigger the selected cases to evaluate if they should still be selected.
  dispatch(deselectNonVisibleCases())
}

export default handleShowAllCasesToggle
